import {
  ISetRaptorPlatformId,
  SET_RAPTOR_PLATFORM_ID,
} from '../../types/redux/raptorPlatform/raptorPlatformTypes';

/**
 * Action to set the selected RaptorPlatform ID in Redux store
 * @param raptorPlatformId - UUID string of the platform or undefined to clear selection
 * @returns Action object
 */
export const setRaptorPlatformId = (
  raptorPlatformId: string | undefined,
): ISetRaptorPlatformId => ({
  type: SET_RAPTOR_PLATFORM_ID,
  raptorPlatformId,
});
